export default {
  'customListGroup.title': 'Gestionar Grupos de Listas',

  'customListGroup.form.id': 'ID',
  'customListGroup.form.enable': 'Habilitar',
  'customListGroup.form.name': 'Nombre',
  'customListGroup.form.description': 'Descripción',

  'customListGroup.form.statusLabel': '¿Elemento Habilitado?',

  'customListGroup.enabled': 'Habilitado',
  'customListGroup.disabled': 'Deshabilitado',
};
